import date from "@wielink-application/shared/js/mixins/dateProps.js";
export default date;